import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../../../components/Spinner';
import { useRecordAttachments } from '../../../../../../../../../../services/record-service';
import ArchivedModal from '../../../../../../../modals/ArchivedModal';

import { COLUMNS } from './columns';

const ArchivedAttachmentsModal = ({ recordId }) => {
  const { data, isLoading } = useRecordAttachments(recordId);

  const archivedAttachments = useMemo(() => {
    if (isLoading) {
      return [];
    }

    return data.filter(attachment => !!attachment.url && attachment.status === 'archived');
  }, [data, isLoading]);

  if (isLoading) {
    return (
      <Flex
        justifyContent="center"
        position="relative"
      >
        <LoadingSpinner isInline minHeight="200px" />
      </Flex>
    );
  }

  return (
    <ArchivedModal data={archivedAttachments} tableColumns={COLUMNS} />
  );
};

ArchivedAttachmentsModal.propTypes = { recordId: PropTypes.number.isRequired };

export default ArchivedAttachmentsModal;
